module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-140.aec05e6c.svg";